module.exports = __webpack_public_path__ + "static/media/tiktok.068c4fac.svg";